import { Footer } from "../../components/layouts/footer";
import { Header } from "../../components/layouts/header";
import { TransformationTop } from "../../pages/home/components/transformation-top";
import { BlueHero } from "../components/blue-hero";
import ContactForm from "../components/contact-form";

export default function ContactPage() {
  return (
    <div className="bg-[#EFF3FD]">
      <Header />
      <BlueHero title="Contact Us" subtext="We'll love to hear from you" />
      <ContactForm />
      <TransformationTop />
      <Footer />
    </div>
  );
}
